var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFastRewind = function SvgFastRewind(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.95 16.975-6.2-4.15a1 1 0 0 1-.338-.362A1 1 0 0 1 13.3 12q0-.25.112-.463a1 1 0 0 1 .338-.362l6.2-4.15a.6.6 0 0 1 .275-.125q.15-.025.275-.025.4 0 .7.275t.3.725v8.25q0 .45-.3.725t-.7.275a2 2 0 0 1-.275-.025.6.6 0 0 1-.275-.125m-10 0-6.2-4.15a1 1 0 0 1-.338-.362A1 1 0 0 1 3.3 12q0-.25.112-.463a1 1 0 0 1 .338-.362l6.2-4.15a.6.6 0 0 1 .275-.125q.15-.025.275-.025.4 0 .7.275t.3.725v8.25q0 .45-.3.725t-.7.275a2 2 0 0 1-.275-.025.6.6 0 0 1-.275-.125"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFastRewind);
export { ForwardRef as ReactComponent };